import React, { Children, cloneElement, isValidElement, PropsWithChildren } from 'react';

import { Box, Divider, Typography } from '@mui/material';

interface Props {
    active: string;
    className?: string;
}

const SortBlock: React.FC<PropsWithChildren<Props>> = ({ active, children, className }) => {
    return (
        <Box sx={{ display: 'flex', alignItems: 'center', gap: '6px' }} className={className}>
            <Typography variant="body2">{'Order by:'}</Typography>
            {Children.map(children, (child, index) => {
                const item = isValidElement<{ active: string }>(child) ? cloneElement(child, { active }) : child;
                return index === 0 ? (
                    item
                ) : (
                    <>
                        <Divider
                            flexItem
                            orientation="vertical"
                            sx={{ background: 'currentColor', color: 'inherit', margin: '2px 0' }}
                        />
                        {item}
                    </>
                );
            })}
        </Box>
    );
};

export default SortBlock;
